import { render, staticRenderFns } from "./MpCard.vue?vue&type=template&id=fc117a5c&scoped=true&"
import script from "./MpCard.vue?vue&type=script&lang=js&"
export * from "./MpCard.vue?vue&type=script&lang=js&"
import style0 from "./MpCard.vue?vue&type=style&index=0&id=fc117a5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc117a5c",
  null
  
)

export default component.exports